module.exports = __webpack_public_path__ + "img/info.bfc6dab6.png";